module.exports = __webpack_public_path__ + "img/4_brendan_n.5d8ad4d4.png";